export default __webpack_public_path__ + "static/SharpSansNo1-Bold-2b087dbd5029c070b20a4f62196ba4b9.eot";